define('drops/simpleSpreadsheet/simpleSpreadsheetRow',[
    'jquery',
    'lq/constants',
    'lq/style',
    'jquery.numpadDecSeparator'
], function ($, constants, Style, numpadDecSeparator) {
    'use strict';
    
    function SimpleSpreadsheetRow(spreadsheet) {
        this.spreadsheet = spreadsheet;

        this.$cells = _(spreadsheet.data.columns.length).times(this.createCell.bind(this));

        this.$element = $('<div />')
            .on('click', this.rowClicked.bind(this))
            .append(_.map(this.$cells, function($cell, i) {
                return $('<div />')
                    .append($cell);
            }));
    }

    SimpleSpreadsheetRow.prototype.createCell = function (i) {
        var $input = $('<input type="text" />')
            .on('change', this.columnUpdated.bind(this, i))
            .on('input', this.columnUpdated.bind(this, i))
            .on('keypress', this.keyPressed.bind(this, i))
            .on('focus', this.focusReceived.bind(this))
            .on('blur', this.focusLost.bind(this));

        if (this.isNumberColumn(i)) {
            $input
                .numpadDecSeparator({
                    separator: this.spreadsheet.formatter.decimalSeperator
                });
        }

        Style.renderStyles(this.spreadsheet, null, $input, this.spreadsheet.data.styles, 'input');

        // overwrite whatever value text-align was set to by Style.renderStyles
        $input.css('text-align', this.spreadsheet.data.columns[i].alignment);

        return $input;
    };

    SimpleSpreadsheetRow.prototype.isNumberColumn = function(i) {
        return this.spreadsheet.data.columns[i].type === 'number';
    };

    SimpleSpreadsheetRow.prototype.rowClicked = function (event) {
        if (event.ctrlKey)
            this.spreadsheet.updateSelectedRows(this);
        else
            this.spreadsheet.setSelectedRow(this);
    };

    SimpleSpreadsheetRow.prototype.focusReceived = function (event) {
        Style.renderStyles(this, null, $(event.target), this.spreadsheet.data.styles, 'input selected');
    };

    SimpleSpreadsheetRow.prototype.focusLost = function (event) {
        Style.renderStyles(this, null, $(event.target), this.spreadsheet.data.styles, 'input');
    };

    SimpleSpreadsheetRow.prototype.columnUpdated = function (indexOfColumn) {
        this.spreadsheet.columnUpdated(indexOfColumn);
    };

    SimpleSpreadsheetRow.prototype.keyPressed = function(indexOfColumn, e) {
        if (e.keyCode !== 13)
            return;
        this.spreadsheet.moveToNextRow(this, indexOfColumn);
    };

    SimpleSpreadsheetRow.prototype.highlight = function() {
        this.$element.addClass('active-row');
    };

    SimpleSpreadsheetRow.prototype.isEmpty = function () {
        var self = this;
        return _.every(this.spreadsheet.data.columns, function (column, i) {
            return !self.$cells[i].val();
        });
    };

    SimpleSpreadsheetRow.prototype.dehighlight = function () {
        this.$element.removeClass('active-row');
    };

    SimpleSpreadsheetRow.prototype.paste = function (content) {
        var values = content.split(';');
        for (var i = 0; i < values.length && i < this.$cells.length; i++) {
            var value = values[i];
            var $cell = this.$cells[i];
            $cell.val(value);
        }
    };
    
    SimpleSpreadsheetRow.prototype.setValueOf = function (indexOfColumn, value) {
        if (this.isNumberColumn(indexOfColumn))
            value = this.convertToNumericValue(value);

        var $cell = this.$cells[indexOfColumn];
        $cell.val(value);
    };

    SimpleSpreadsheetRow.prototype.convertToNumericValue = function (value) {
        return this.spreadsheet.formatter.convertFromLicquidFormat(constants.valueTypes.decimal, value);
    };
    
    SimpleSpreadsheetRow.prototype.getNumericValueOf = function (indexOfColumn) {
        var value = this.$cells[indexOfColumn].val();
        var numericValue = this.spreadsheet.formatter.convertToLicquidFormat(constants.valueTypes.decimal, value);
        return numericValue === NaN ? null : numericValue;
    };
    
    SimpleSpreadsheetRow.prototype.setData = function (data) {
        var self = this;
        _.each(this.spreadsheet.data.columns, function (column, i) {
            var value = data[column.attribute];
            self.setValueOf(i, value);
        });
    };

    SimpleSpreadsheetRow.prototype.getData = function () {
        var data = {};

        var self = this;
        _.each(this.spreadsheet.data.columns, function (column, i) {
            data[column.attribute] = self.isNumberColumn(i) ?
                self.getNumericValueOf(i)
                : self.$cells[i].val();
        });

        return data;
    };

    SimpleSpreadsheetRow.prototype.focusFirstInputField = function () {
        this.focusInputField(0);
    };

    SimpleSpreadsheetRow.prototype.focusInputField = function(index) {
        this.$element.find('input')
            .eq(index)
            .trigger('focus');
    };

    return SimpleSpreadsheetRow;
});
